// Profile of Nikolai Genov, Polish. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • ochrona zdrowia, nauki o życiu, finanse',
  summary: 'Doktor bioinformatyki i lider techniczny czynnie zaangażowany w realizację, łączący inżynierię oprogramowania wspomaganą przez AI z analityką w regulowanych obszarach ochrony zdrowia, nauk o życiu i finansów. Wiedza ekspercka obejmuje systemy LLM/RAG, integrację MCP, dane kliniczne, prognozy bankowe w horyzoncie do pięciu lat oraz zautomatyzowane raportowanie w Excelu. Łączy implementację w R/Pythonie z koordynacją zespołu, zapewnianiem jakości i warsztatami dla kadry zarządzającej; posiada certyfikat AI Act i ukończył szkolenie GCP.',
  imageAlt: 'Portret Nikolaia Genova',
  personal: {
    position: 'Współzałożyciel i dyrektor zarządzający pAIoneer Labs GmbH, dyrektor zarządzający Leap Dynamics GmbH',
    location: 'Berlin, Niemcy',
    languages: 'Niemiecki i angielski (biegle), bułgarski (biegle)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'Certyfikat AI Act, szkolenie GCP (2025)',
    publications: 'Recenzowane publikacje w Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology i PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Doktorat: bioinformatyka / biologia teoretyczna',
      institution: '',
      degree: 'Stopień: doktor (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Studia: bioinformatyka',
      institution: 'Freie Universität Berlin',
      degree: 'Tytuł: M.Sc. w zakresie bioinformatyki'
    },
    {
      period: '2012',
      field: 'Studia: bioinformatyka',
      institution: 'Freie Universität Berlin',
      degree: 'Tytuł: B.Sc. w zakresie bioinformatyki'
    }
  ],
  skills: [
    {
      title: 'Kluczowe kompetencje',
      description: 'Inżynieria wspomagana przez AI, R/Python, LLM/RAG i MCP, dane kliniczne i bioinformatyka, prognozowanie i testy warunków skrajnych, raportowanie w Excelu, Shiny, przywództwo techniczne'
    },
    {
      title: 'Programowanie i analityka',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Aplikacje i raportowanie',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; zautomatyzowane raportowanie w formatach Excel/Word/PDF'
    },
    {
      title: 'AI i integracja',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; wytwarzanie oprogramowania wspomagane przez AI, z weryfikacją przez człowieka'
    },
    {
      title: 'Inżynieria',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bioinformatyka',
      description: 'RNA-seq, mikromacierze, alternatywny splicing/izoformy, analiza wzbogacenia zbiorów genów, analiza szlaków i sieci, składanie genomów, analiza przeżycia; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Dane kliniczne',
      description: 'EDC, CRF, edit checks, DMP, plany walidacji danych, UAT, rekoncyliacja SAE; CDISC SDTM/ADaM, potoki RAW/SDTM/ADaM, QC'
    }
  ],
  positions: [
    {
      period: '2022 - kwiecień 2024',
      title: 'Automatyzacja raportowania, T-Systems / Europejski Bank Centralny (EBC)',
      description: [
        'Zbudowanie biblioteki R do raportowania statystycznego finansowych szeregów czasowych; migracja logiki FAME do R/Pythona z użyciem Reticulate oraz automatyzacja dokumentów wynikowych Word/PDF.',
        'Opracowanie potoków do automatycznego generowania raportów w Excelu; integracja analityki z Camundą oraz wsparcie GitLab CI/CD, testów jednostkowych, lintingu, SonarQube i dokumentacji.',
        'Zastępowanie lidera zespołu oraz udział w planowaniu sprintów, koordynacji technicznej, zapewnianiu jakości i realizacji prac w bezpośrednim kontakcie z interesariuszami.'
      ]
    },
    {
      period: 'czerwiec 2025 - grudzień 2025',
      title: 'Data Science & Risk Analytics Consultant, bankowość',
      description: [
        'Opracowanie modeli prognostycznych o horyzontach planowania do pięciu lat oraz wdrożenie testów warunków skrajnych.',
        'Przepisanie i refaktoryzacja zastanego kodu R, optymalizacja czterech procesów biznesowych oraz wykorzystanie wytwarzania oprogramowania wspomaganego przez AI, z weryfikacją przez człowieka, przy implementacji i dokumentacji.',
        'Zbudowanie procesów analitycznych w R/Shiny oraz potoków do automatycznego generowania raportów w Excelu; przełożenie wymagań biznesowych na implementacje analityczne.'
      ]
    },
    {
      period: 'czerwiec 2025 - czerwiec 2026',
      title: 'Clinical Data Manager, farmacja / badania kliniczne',
      description: [
        'Prowadzenie konfiguracji EDC, projektu CRF, edit checks, ról użytkowników, specyfikacji transferu danych i UAT; koordynacja współpracy z CRO, laboratoriami i zespołami badawczymi.',
        'Tworzenie i przegląd DMP, planów walidacji, planów rekoncyliacji SAE i dokumentacji UAT; opracowanie procesów walidacji opartych na R oraz aplikacji Shiny w środowisku podlegającym GCP.'
      ]
    },
    {
      period: 'lipiec 2026',
      title: 'Potok danych klinicznych, Dr. Falk Pharma',
      description: [
        'Zbudowanie potoku RAW/SDTM/ADaM w R z użyciem OpenCode i wytwarzania oprogramowania wspomaganego przez AI, wraz z walidacją, QC, identyfikowalnością i potokami automatycznych raportów w Excelu.'
      ]
    },
    {
      period: '2026',
      title: 'Raportowanie ścieżki audytu (audit trail) wspomagane przez AI, Miltenyi Biotec',
      description: [
        'Wykorzystanie OpenCode i wytwarzania oprogramowania wspomaganego przez AI do wdrożenia raportów ścieżki audytu oraz potoków automatycznych raportów w Excelu, w tym logiki raportowania, debugowania, dokumentacji i weryfikacji przez człowieka.'
      ]
    },
    {
      period: '2019 - obecnie',
      title: 'CEO i współzałożyciel / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Kierowanie doradztwem i realizacją techniczną w obszarach ochrony zdrowia, nauk o życiu, finansów i AI; łączenie własnej pracy wdrożeniowej z koordynacją zespołu i komunikacją z interesariuszami.',
        'Zaprojektowanie infrastruktury LLM/RAG oraz integracji narzędzi opartej na MCP. Wprowadzenie wspomaganych przez OpenCode procesów pracy w R/Pythonie do generowania kodu, refaktoryzacji, testowania i dokumentacji z weryfikacją przez człowieka.'
      ]
    },
    {
      period: '2022 - obecnie',
      title: 'Rejestr onkologiczny i biobank, Medical University Pleven',
      description: [
        'Analiza danych krajowego rejestru nowotworów i zbudowanie dashboardów Shiny dla interesariuszy klinicznych i naukowych; wsparcie integracji, dokumentacji i procesów biobanku dla pięciu typów nowotworów.'
      ]
    },
    {
      period: '2025 - obecnie',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Zbudowanie gotowej do pracy produkcyjnej aplikacji R Shiny; migracja danych CSV do SQLite oraz dodanie uwierzytelniania administratora, zarządzania instytucjami, analityki odwiedzin, płatnych wpisów i formularzy zapytań z powiadomieniami SMTP.',
        'Udoskonalenie responsywnego UI/UX, SEO, danych strukturalnych oraz obsługi sitemap/robots; dodanie walidacji danych wejściowych, escapowania danych wyjściowych, ograniczania prób logowania i publikowania wyłącznie zweryfikowanych rekordów. Audyt ponad 400 instytucji z wykorzystaniem ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT i AI-on-Demand, wraz z dokumentacją pochodzenia danych oraz wdrożenia i bezpieczeństwa.'
      ]
    },
    {
      period: '2024 - obecnie',
      title: 'Analityka wiadomości finansowych oparta na LLM, Leap Dynamics (projekt wewnętrzny)',
      description: [
        'Zbudowanie cyklicznych procesów analizy sentymentu z wykorzystaniem LLM, danych z API, automatycznych raportów PDF, interfejsu Streamlit, orkiestracji n8n i testowania procesów wspomaganego przez Flowise.'
      ]
    },
    {
      period: '2025',
      title: 'Warsztaty dla kadry zarządzającej, BVMW',
      description: [
        'Prowadzenie warsztatów dla uczestników na szczeblu dyrektorów zarządzających w sieci BVMW.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Pracownik naukowy, Uniwersytet Humboldtów / Charité, Berlin',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO i współzałożyciel, Promethano GmbH',
      description: [
        'Oprogramowanie dla nauk o życiu i aplikacje oparte na szeregach czasowych.'
      ]
    }
  ]
};
